/**
 * formatReadonly — the field zone's ONE display formatter for a manifest
 * entry's `format` prop (Bob P1 item 2a, Phase 2).
 *
 * Extracted verbatim from FieldRecordModal's readonlyRow, where it was a
 * closure over nothing, so the records grid can render a formatted column
 * exactly as the record form does: one definition, two consumers. The
 * rationale for the manifest-driven format and the numeric guard is in the
 * comment above readonlyRow in FieldRecordModal.jsx.
 *
 * Callers own the EMPTY case and must test it first: Number('') and
 * Number(null) are 0, so an empty value reaching the 'comma' branch would
 * render as "0". The form renders empties as '—', the grid as a blank cell.
 */
export function formatReadonly(f, v) {
  if (f.format === 'comma') {
    const n = Number(v);
    if (Number.isFinite(n)) return n.toLocaleString('en-US');
  }
  return String(v);
}
